import { logError } from "common/error";
import { cancel, delayAnimation } from "common/promises";
import { Sheets } from "common/sheets";
class WalkEventListeners {
    constructor() {
        this.listeners = [];
    }
    walk(time) {
        for (const listener of this.listeners) {
            listener.walk(time);
        }
    }
    add(listener) {
        this.listeners.push(listener);
    }
    reset() {
        this.listeners = [];
    }
}
export class Person {
    constructor(pixiContext, sheets) {
        // 1 step for a sec.
        this.speed = 1;
        this.walking = null;
        this.walkWaiting = 0;
        this.listeners = new WalkEventListeners();
        this.finished = false;
        this.idle = null;
        this.totalCanceler = new cancel.Canceler();
        this.sprite = Sheets.animation(pixiContext, sheets, imageName);
        this.startIdle();
    }
    stop() {
        if (this.walking != null) {
            this.walking.canceler.cancel();
            this.walking = null;
        }
        if (this.idle != null) {
            this.idle.canceler.cancel();
            this.idle = null;
        }
        this.listeners.reset();
        this.totalCanceler.cancel();
    }
    finish() {
        this.finished = true;
        this.walk().catch(logError);
    }
    startIdle() {
        var _a;
        (_a = this.idle) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
        this.idle = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sprite.gotoAndStop(16);
                await delayAnimation(100);
                canceler.check();
                this.sprite.gotoAndStop(17);
                await delayAnimation(100);
            }
        });
    }
    stopIdle() {
        var _a;
        (_a = this.idle) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
    }
    async walk() {
        if (this.walking != null) {
            this.walking.canceler.cancel();
            this.walkWaiting += 1;
            const myWaiting = this.walkWaiting;
            await this.walking.promise;
            if (myWaiting != this.walkWaiting) {
                return;
            }
        }
        this.walking = cancel.root(async (canceler) => {
            this.stopIdle();
            const walkTime = 500 * [1, 1 / 1.3, 1 / 1.8, 1 / 2][this.speed - 1];
            switch (this.speed) {
                case 1:
                    this.listeners.walk(walkTime * 2);
                    await this.leftStep(this.totalCanceler, walkTime);
                    await this.rightStep(this.totalCanceler, walkTime);
                    break;
                case 2:
                    this.listeners.walk(walkTime * 2);
                    await this.leftStep(this.totalCanceler, walkTime);
                    await this.rightStep(this.totalCanceler, walkTime);
                    canceler.check();
                    this.listeners.walk(walkTime * 2);
                    await this.leftStep(this.totalCanceler, walkTime);
                    await this.rightStep(this.totalCanceler, walkTime);
                    break;
                case 3:
                case 4:
                    this.listeners.walk(walkTime * 2);
                    await this.leftStep(this.totalCanceler, walkTime);
                    await this.rightStep(this.totalCanceler, walkTime);
                    canceler.check();
                    this.listeners.walk(walkTime * 2);
                    await this.leftStep(this.totalCanceler, walkTime);
                    await this.rightStep(this.totalCanceler, walkTime);
                    canceler.check();
                    this.listeners.walk(walkTime * 2);
                    await this.leftStep(this.totalCanceler, walkTime);
                    await this.rightStep(this.totalCanceler, walkTime);
                    while (this.finished) {
                        canceler.check();
                        this.listeners.walk(walkTime * 2);
                        await this.leftStep(this.totalCanceler, walkTime);
                        await this.rightStep(this.totalCanceler, walkTime);
                    }
                    break;
            }
            this.startIdle();
        });
    }
    async leftStep(canceler, time) {
        const wait = time / 8;
        for (let i = 0; i < 8; i += 1) {
            canceler.check();
            this.sprite.gotoAndStop(i);
            await delayAnimation(wait);
        }
    }
    async rightStep(canceler, time) {
        const wait = time / 8;
        for (let i = 0; i < 8; i += 1) {
            canceler.check();
            this.sprite.gotoAndStop(i + 8);
            await delayAnimation(wait);
        }
    }
}
export const imageName = "인물 중앙";
//# sourceMappingURL=person.js.map